import axios from 'axios';
import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';

const ListJobVacancyForm = () => {

    const { state, handleFunction } = useContext(GlobalContext);

    let { IdData } = useParams();

    let {
        input,
        setInput,
    } = state

    let {
        handleInput,
        handleSubmit
    } = handleFunction

    useEffect(() => {
        if (IdData !== undefined) {
            axios.get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`).then((res) => {
                let data = res.data

                setInput(
                    {
                        title: data.title,
                        job_description: data.job_description,
                        job_qualification: data.job_qualification,
                        job_type: data.job_type,
                        job_tenure: data.job_tenure,
                        job_status: data.job_status,
                        company_name: data.company_name,
                        company_image_url: data.company_image_url,
                        company_city: data.company_city,
                        salary_min: data.salary_min,
                        salary_max: data.salary_max,
                    }
                )
            }).catch((error) => {
                console.log(error);
            })
        }
    }, [])

    return (
        <div className='w-full border-b border-solid border-stone-200'>
            <h1 className='px-4 py-4 text-5xl sm:text-xl md:text-2xl lg:text-3xl font-bold'>
                Form Job
            </h1>
            <div className='my-4 mx-4'>
                <form onSubmit={handleSubmit}>
                    <div className="w-full grid-cols-2 gap-4 xl:grid lg:grid md:block sm:block">
                        <div className="mb-6">
                            <label
                                htmlFor="title"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Title
                            </label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                onChange={handleInput}
                                value={input.title}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="job_description"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Job Description
                            </label>
                            <textarea
                                type="text"
                                id="job_description"
                                name="job_description"
                                onChange={handleInput}
                                value={input.job_description}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="job_qualification"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Job Qualification
                            </label>
                            <input
                                type="text"
                                id="job_qualification"
                                name="job_qualification"
                                onChange={handleInput}
                                value={input.job_qualification}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="job_type"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Job Type
                            </label>
                            <input
                                type="text"
                                id="job_type"
                                name="job_type"
                                onChange={handleInput}
                                value={input.job_type}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="job_tenure"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Job Tenure
                            </label>
                            <input
                                type="text"
                                id="job_tenure"
                                name="job_tenure"
                                onChange={handleInput}
                                value={input.job_tenure}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>


                        <div className="mb-6">
                            <label
                                htmlFor="job_status"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Job Status
                            </label>
                            <input
                                type="number"
                                id="job_status"
                                name="job_status"
                                onChange={handleInput}
                                value={input.job_status}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required min={0} max={1}
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="company_name"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Company Name
                            </label>
                            <input
                                type="text"
                                id="company_name"
                                name="company_name"
                                onChange={handleInput}
                                value={input.company_name}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="company_image_url"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Company Image
                            </label>
                            <input
                                type="text"
                                id="company_image_url"
                                name="company_image_url"
                                onChange={handleInput}
                                value={input.company_image_url}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="company_city"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Company City
                            </label>
                            <input
                                type="text"
                                id="company_city"
                                name="company_city"
                                onChange={handleInput}
                                value={input.company_city}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="salary_min"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Salary Min
                            </label>
                            <input
                                type="number"
                                id="salary_min"
                                name="salary_min"
                                onChange={handleInput}
                                value={input.salary_min}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required min={0}
                            />
                        </div>
                        <div className="mb-6">
                            <label
                                htmlFor="salary_max"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Salary Max
                            </label>
                            <input
                                type="number"
                                id="salary_max"
                                name="salary_max"
                                onChange={handleInput}
                                value={input.salary_max}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                required min={0}
                            />
                        </div>
                    </div>
                    <button
                        type={"submit"}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    )
}

export default ListJobVacancyForm;
